import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { format } from 'date-fns';
import { useDispatch } from 'react-redux';
import * as Icon from 'react-feather';
import { getFileExtension } from '../../../utils/common';
import PropTypes from 'prop-types';
import { getChatReportHistory } from '../../../store/slices/tenantSlices/chatSlice';
import config from '../../../config';

const ChatReportInfo = ({ setIsPreviewUrl, isOpen, handleCancel, details }) => {
  const dispatch = useDispatch();

  const [chatHistory, setChatHistory] = useState([]);

  const chatReportHistoryGet = async () => {
    try {
      const payload = {
        start_date: details?.from_date,
        end_date: details?.to_date,
        type: details?.type,
        from_userId: details?.from_userId,
        to_userId: details?.to_userId
      };
      const response = await dispatch(getChatReportHistory(payload)).unwrap();
      setChatHistory(response?.data);
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      chatReportHistoryGet();
    }
  }, [details, isOpen]);

  const getFileName = (path) => {
    const pathnames = path?.split('/');
    return pathnames?.[pathnames.length - 1];
  };

  const fileDownload = async (url) => {
    try {
      const response = await fetch(url, {
        mode: 'cors' // or 'no-cors' if needed — but only if you're not accessing the response body
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;

      // Get filename from URL
      const filename = url.split('/').pop();
      link.download = filename || 'download';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Revoke the object URL after use to free up memory
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
      toggle={handleCancel}>
      <ModalHeader toggle={handleCancel} className="d-flex justify-content-center fs-6">
        Chat Details
      </ModalHeader>
      <ModalBody style={{ height: 'calc(100vh - 180px)' }}>
        <div className="chat-app__messages flex-grow-1 p-3 overflow-auto h-100">
          {chatHistory?.length > 0 ? (
            chatHistory.map((msg, idx) => {
              const isSentByCurrentUser = msg.fromUserId === details?.from_userId;
              const formattedTime = format(new Date(msg.timestamp), 'hh:mm a');
              const extension = getFileExtension(msg?.filePath);
              return (
                <div
                  key={msg._id}
                  className={`chat-app__message-wrapper ${isSentByCurrentUser ? 'sent' : 'received'}`}>
                  <div className={`chat-app__message ${msg?.filePath ? 'chat-app__media' : ''}`}>
                    {msg?.filePath ? (
                      <div className="chat-app__message-text">
                        {extension === 'pdf' ? (
                          <div>
                            {msg?.fileName ? msg?.fileName : getFileName(msg?.filePath)}
                            <div className="media-icon">
                              <Icon.FileText size={40} />
                            </div>
                            <div className="w-100 d-flex align-items-center gap-1">
                              <div className="w-50">
                                <Button
                                  className="w-100"
                                  style={{ fontSize: '12px' }}
                                  onClick={() =>
                                    setIsPreviewUrl(
                                      `${config.BASE_URL}${msg?.filePath}`
                                    )
                                  }>
                                  Open
                                </Button>
                              </div>
                              <div className="w-50">
                                <Button
                                  className="w-100"
                                  style={{ fontSize: '12px' }}
                                  onClick={() => {
                                    fileDownload(
                                      `${config.BASE_URL}${msg?.filePath}`
                                    );
                                  }}>
                                  Download
                                </Button>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div>
                            {msg?.fileName ? msg?.fileName : getFileName(msg?.filePath)}
                            <div className="image-wrapper">
                              <img src={`${config.BASE_URL}${msg?.filePath}`} />
                            </div>
                            <div className="w-100 d-flex align-items-center gap-1">
                              <div className="w-50">
                                <Button
                                  className="w-100"
                                  style={{ fontSize: '12px' }}
                                  onClick={() =>
                                    setIsPreviewUrl(
                                      `${config.BASE_URL}${msg?.filePath}`
                                    )
                                  }>
                                  Open
                                </Button>
                              </div>
                              <div className="w-50">
                                <Button
                                  className="w-100"
                                  style={{ fontSize: '12px' }}
                                  onClick={() => {
                                    fileDownload(
                                      `${config.BASE_URL}${msg?.filePath}`
                                    );
                                  }}>
                                  Download
                                </Button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="chat-app__message-text">{msg.message}</div>
                    )}
                    <div className="chat-app__message-time">{formattedTime}</div>
                  </div>
                </div>
              );
            })
          ) : (
            <div
              style={{
                height: 'calc(100vh - 250px)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
              <span style={{ color: '#888', fontSize: '16px' }}>No history found</span>
            </div>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

ChatReportInfo.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func,
  setIsPreviewUrl: PropTypes.func,
  details: PropTypes.object
};

export default ChatReportInfo;
